import * as z from "zod/v4";

export const getTrackstarLinkToken = {
  name: "getTrackstarLinkToken" as const,
  input: z.object({}),
  output: z.object({ linkToken: z.string().nullable() }),
};
